module.exports = __webpack_public_path__ + "img/mana_generator_small.61ec62f7.png";